import React from 'react'
import * as Fields from 'support/fields'
import { Translation } from '@morningtrain/react-translations'
import { Fieldset } from 'layouts'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import { WhenModelValue } from '@morningtrain/react-resources'
import * as UI from 'ui'
import ContentCodeSection from 'pages/app/emailtemplates/smartviews/ContentCodeSection'

export default function EmailTemplateForm () {
  return (
    <Fieldset>
      <UpdateModelOnChange name='slug'>
        <Fields.Select
          enum='email_template_slug'
          name='slug'
          label={<Translation name='fields.type.label' />}
        />
      </UpdateModelOnChange>
      <Fields.TabsField
        enum='language'
        name='lang'
        label={<Translation name='fields.lang.label' />}
      />
      <Fields.Input
        name='subject'
        label={<Translation name='fields.subject.label' />}
      />
      <div className='form-element'>
        <UI.Text weight='medium' className='mb-4'>
          <Translation name='fields.emailcontent.fieldstitle' />
        </UI.Text>
        <WhenModelValue name='slug' condition='activated_contract'>
          <ContentCodeSection name='name' code='NAME' />
          <ContentCodeSection name='email' code='EMAIL' />
          <ContentCodeSection name='contract_title' code='CONTRACT_TITLE' />
        </WhenModelValue>
        <WhenModelValue name='slug' condition='user_welcome'>
          <ContentCodeSection name='name' code='NAME' />
          <ContentCodeSection name='email' code='EMAIL' />
          <ContentCodeSection name='password' code='PASSWORD' />
          <ContentCodeSection name='first_shift_at' code='FIRST_SHIFT_AT' />
          <ContentCodeSection name='signup_link' code='SIGNUP_LINK' />
        </WhenModelValue>
        <WhenModelValue name='slug' condition='user_department_welcome'>
          <ContentCodeSection name='name' code='NAME' />
          <ContentCodeSection name='email' code='EMAIL' />
          <ContentCodeSection name='department' code='DEPARTMENT' />
        </WhenModelValue>
        <WhenModelValue name='slug' condition='contract_signed'>
          <ContentCodeSection name='name' code='NAME' />
          <ContentCodeSection name='contract_title' code='CONTRACT_TITLE' />
        </WhenModelValue>
      </div>
      <Fields.TextArea
        name='content'
        label={<Translation name='fields.content.label' />}
        height={250}
      />
    </Fieldset>
  )
}
